<template>
  <div>
      <el-form label-width="100px">
        <el-form-item label="选择日期范围">
          <el-col :span="12">
            <el-date-picker
                    v-model="vdate"
                    type="daterange"
                    alue-format="yyyy-MM-dd"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 100%;"
                    :picker-options="pickerOptions"
                    value-format="yyyy-MM-dd"
                    @change="dateChange">
            </el-date-picker>
          </el-col>
          <!--<el-col :span="12">-->
            <!--<el-button type="primary" @click="exportData" v-loading="exportloading">导出</el-button>-->
            <!--<el-popover-->
                    <!--placement="top-start"-->
                    <!--width="200"-->
                    <!--trigger="hover"-->
                    <!--content="导出任务会以队列执行，点击导出后，请至‘设置-导出列表’页面中查看及下载数据">-->
              <!--<i class="el-icon-question" slot="reference"></i>-->
            <!--</el-popover>-->
          <!--</el-col>-->
        </el-form-item>
      </el-form>
      <el-row :gutter="20">
        <el-col :span="17">
          <section class="section-card realtime-statics" v-loading="userloading">
            <div class="section-card-header">
              <div class="section-card-title">
                实时概况
              </div>
              <div class="header-small">
                更新时间：{{Date.now()/1000 | datetime('yyyy-MM-dd hh:mm:ss')}}
              </div>
            </div>
            <div>
              <el-row class="analysis" :gutter="20">
                <el-col :span="12">
                  <div class="view-flex">
                    <div class="view-flex-item">
                      <div class="label">投保单数</div>
                      <div class="real-data">{{policyCount}}</div>
                    </div>
                    <div class="view-flex-item">
                      <div class="label">保费总金额</div>
                      <div class="real-data">{{sumPremium}}</div>

                    </div>
                    <div class="view-flex-item">
                      <div class="label">退保单数</div>
                      <div class="real-data">{{refundCount}}</div>

                    </div>
                    <div class="view-flex-item">
                      <div class="label">退保总金额</div>
                      <div class="real-data">{{sumRefundPrice}}</div>

                    </div>
                  </div>
                </el-col>

              </el-row>

            </div>
          </section>
        </el-col>
      </el-row>
    <el-tabs v-if="$route.path.indexOf('_editor') === -1" v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="保单明细" name="sum_amount_count" v-loading="loading">
        <template>
          <el-table :data="allListData" stripe border style="width: 100%" :height="wheight-230">
            <el-table-column prop="policyNo" label="凭证号"></el-table-column>
            <el-table-column prop="premium" label="保费"></el-table-column>
            <el-table-column prop="status" label="状态"></el-table-column>
          </el-table>
        </template>
      </el-tab-pane>
      <div class="content-padded content-center">
        <el-pagination
                background
                layout="total, sizes, prev, pager, next"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                :current-page.sync="params.page"
                :page-sizes="[10,20,50]"
                :total="total_count"
                :page-size="params.pageSize">
        </el-pagination>
      </div>
    </el-tabs>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import json2csv from 'json2csv'
    import { getCheckOrderData } from '../../api/datacube'
    export default {
        data () {
            return {
                vdate: '',
                loading: true,
                exportloading: false,
                policyCount:0,
                sumPremium:0,
                refundCount:0,
                sumRefundPrice:0,
                total_count:0,
                activeName: 'sum_amount_count',
                params: {
                    start:new Date().getFullYear()+"-" + (new Date().getMonth()+1) + "-" + (new Date().getDate()-1),
                    end: new Date().getFullYear()+"-" + (new Date().getMonth()+1) + "-" + (new Date().getDate()-1),
                    page: 1,
                    pageSize: 20,
                },
                allListData: [],
                fields: ['policyNo','premium','status'],
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一天',
                        onClick(picker) {
                            const start = new Date();
                            const end = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一周',
                        onClick(picker) {
                            const start = new Date();
                            const end = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                }
            }
        },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {
            exportData () {
                this.exportloading = true
                this.params.export = 1
                getCheckOrderData(this.params).then(res => {
                    console.log(res);
                    this.exportloading = false
                    if (res.data.status) {
                        this.$message({
                            type: 'success',
                            message: '已加入执行队列，请在设置-导出列表中下载'
                        })
                        return
                    } else if (res.data.url) {
                        this.downloadUrl = res.data.url
                        this.downloadName = res.data.filename
                        this.downloadView = true
                    } else {
                        this.$message({
                            type: 'error',
                            message: '无内容可导出 或 执行失败，请检查重试'
                        })
                        return
                    }
                }).catch( error => {
                    this.exportloading = false
                })
            },
            createDownLoadClick(content, fileName) {
                const link = document.createElement("a");
                link.href = encodeURI(content);
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },
            handleCurrentChange (page_num) {
                console.log(page_num);
                this.loading = false
                this.params.page = page_num
                this.getParams()
                this.getAmountData(this.params)
            },
            handleSizeChange (pageSize) {
                console.log(pageSize);
                this.loading = false
                this.params.page = 1
                this.params.pageSize = pageSize
                this.getParams()
                this.getAmountData(this.params)
            },
            getParams () {
                console.log(this.params.start)
                console.log(this.params.end)

                this.params.start = this.params.start
                this.params.end = this.params.end
            },
            MyBrowserIsIE() {
                let isIE = false;
                if (
                    navigator.userAgent.indexOf("compatible") > -1 &&
                    navigator.userAgent.indexOf("MSIE") > -1
                ) {
                    // ie浏览器
                    isIE = true;
                }
                if (navigator.userAgent.indexOf("Trident") > -1) {
                    // edge 浏览器
                    isIE = true;
                }
                return isIE;
            },
            handleClick (tab, event) {
            },
            dateChange (val) {
                if (!val) {
                    return false
                }
                this.params.start = val[0]
                this.params.end = val[1]
                this.params.export = 0
                this.getCheckOrderData()
            },
            getCheckOrderData() {
                this.loading = true
                getCheckOrderData(this.params).then(res => {
                    this.allListData    = res.data.data.policyList
                    this.total_count    = res.data.data.num
                    this.policyCount    = res.data.data.policyCount?res.data.data.policyCount:0
                    this.sumPremium     = res.data.data.sumPremium?res.data.data.sumPremium:0
                    this.refundCount    = res.data.data.refundCount?res.data.data.refundCount:0
                    this.sumRefundPrice = res.data.data.sumRefundPrice?res.data.data.sumRefundPrice:0
                    this.loading = false
                }).catch( error => {
                    this.$message({
                        type: 'error',
                        message: '获取统计信息出错'
                    })
                })
            },
        },
        mounted () {
            var start = new Date();
            var end = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
            this.vdate = [start, end]
            this.getCheckOrderData()
        }
    }
</script>
<style>
  .goods-popover-img{
    margin-top: 5px;
    margin-bottom: 5px;
    background:#000;
    border:1px solid #fff;
    border-width:5px 5px 5px 5px;
    box-shadow:1px 1px 5px #333;
    -webkit-box-shadow:1px 1px 5px #333;
    -moz-box-shadow:1px 1px 5px #333;
  }
</style>
<style scoped lang="scss">
  .main {
    min-width: 1024px;
  }
  .unbind-box {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 285px;
    .iconfont {
      display: block;
      margin-bottom: 20px;
      font-size: 70px;
      line-height: 1;
      color: #eaeaea;
    }
    p {
      margin-bottom: 20px;
    }
  }

  .section-card {
    padding: 30px;
    background: #fff;
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
    &.realtime-statics {
      height: 138px;
    }
    &.chart-statics {
      height: 318px;
    }
    .section-card-header {
      display: flex;
      align-items: flex-end;
      padding-bottom: 20px;
      .section-card-title {
        margin-right: 20px;
        font-size: 16px;
        font-weight: 600;
      }
      .header-small {
        flex: 1;
        font-size: 12px;
        color: #ccc;
      }
      .header-filters {
        display: flex;
        .filter-item {
          position: relative;
          padding: 0 15px;
          color: #999;
          font-size: 12px;
          &::after {
            position: absolute;
            left: 0;
            top: 20%;
            bottom: 20%;
            width: 1px;
            background: #efefef;
            content: "";
          }
          &:first-child::after {
            content: none;
          }
        }
      }
    }
  }

  .company {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 285px;
    .logo {
      margin-bottom: 20px;
      width: 70px;
      height: 70px;
      border-radius: 100%;
    }
    .name {
      margin-bottom: 10px;
      font-size: 14px;
    }
    .operate {
      padding-bottom: 50px;
    }
    .validity-period {
      display: flex;
      font-size: 12px;
      color: #999;
      .iconfont {
        margin-right: 10px;
        font-size: 12px;
      }
    }
  }

  .analysis {
    padding-left: 20px;
    padding-top: 10px;
    .label {
      font-size: 12px;
      color: #999;
    }
    .real-data {
      font-size: 20px;
      font-family: "Helvetica Neue";
      font-weight: 500;
    }
    .history-data {
      font-size: 12px;
      color: #ccc;
    }
  }

  .notices {
    padding-left: 20px;
    .notices-group {
      padding: 10px 0;
    }
    .subtitle {
      padding-bottom: 10px;
      font-size: 14px;
      color: #666;
    }
    .notice-item {
      font-size: 12px;
      color: #999;
      cursor:pointer;
    }
  }

  .quick-link {
    padding-left: 20px;
    .link-item {
      float: left;
      width: 230px;
      margin: 10px 0;
      color: #666;
      cursor:pointer;
      .iconfont {
        display: inline-block;
        margin-right: 10px;
        width: 25px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        border-radius: 5px;
        color: #fff;
        font-size: 12px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// checkoutOrder.vue?152cdd86